import styled from "styled-components";
import { Col, Divider, Table, Drawer, Form, Input, Modal } from "antd";
import {
  DataHeading,
  DataValue,
  PageSectionHeading,
  DisplayFlex,
  GhostButtonComponent,
  PrimaryButtonComponent,
  PrimaryIndicator,
  CommonCard,
  CommonTable,
  SecondaryButtonComponent,
  InvestmentOption,
  CustomSelectBox,
  UnderlineLink,
  InputField,
  EllipsisUnderline
} from "../../CommonComponents/commonStyles";
/*********************************** MY ACCOUNT ************************************************/


export const MyAccountSelect = styled(CustomSelectBox)`

@media(max-width: 767px){
  width: ${props=> props.mobileWidth?props.mobileWidth :"100%"}  !important;
}

.ant-select-selection-selected-value{    
  margin-top: 8px !important;
  @media(max-width: 767px){
    margin-top: 2px !important;
  }
}` ;


export const SectionHeading = styled.h2`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.heading};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.heading};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;
export const AlignItemsCenter1 = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 768px) {
    justify-content: space-between;
  }
`;

export const AlignItemsCenterNew = styled.div`
  display: flex;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 30px;
  @media only screen and (max-width: 768px) {
    justify-content: space-between;
    margin-top: 40px;
    margin-bottom: 20px;
  }
`;

export const AlignItemEnd = styled.div`
  display:flex;
  align-items: flex-end;
  @media only screen and (max-width: 768px) {
    justify-content: space-between;
  }
  
`;

export const AlignItemsCenterJustLeft = styled(AlignItemsCenter1)`
  @media only screen and (max-width: 768px) {
    justify-content: left;
  }
`;

export const PersonnelHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom:7px;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    margin-bottom:5px;
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;

export const JustifyBetweenAccessLevel = styled(DisplayFlex)`
  margin-bottom: 30px;
  justify-content: space-between;
  @media (max-width: 576px) {
    display: block;
    margin-bottom: 30px;
  }
`;
export const AccountNameEdit = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h1};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom: 0px;
  @media only screen and (min-width: 991px){
    input{
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      font-size: ${props => props.theme.fontSize.primary};
      line-height: ${props => props.theme.lineHeight.primary};
      color: ${props => props.theme.fontColors.textColor};
      width:300px !important;
    }
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h2};
    line-height: ${props => props.theme.lineHeight.h2};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h3};
    line-height: ${props => props.theme.lineHeight.oneP17};
  }
`;
export const PrimaryAccount = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 768px) {
    font-size: ${props => props.theme.fontSize.tertiary};
    display: inline-block !important;
    width: 100%;
  }
`;
export const AccountNameEditParent = styled.div`
  display: flex;
  align-items: center;

  @media only screen and (max-width: 768px) {
    font-size: ${props => props.theme.fontSize.tertiary};
    display: inline-block !important;
  }
`;
export const ItemHeading = styled(DataHeading)`
  line-height: ${props => props.theme.lineHeight.twoRem}; 
  flex-shrink:0;
  @media only screen and (max-width: 990px) {
    font-size: 0.9rem;
    line-height: ${props => props.theme.lineHeight.twoRem};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  &.bold-text{
    font-weight:bold;
  }
`;


export const ItemData = styled(DataValue)`
  line-height: ${props => props.theme.lineHeight.twoRem};
  word-break: break-word;
  -ms-word-wrap: break-word;
  max-width : ${props => props.noMaxWidth ? 'none': '250px'};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.twoRem};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;

export const ShowDataButton = styled(SecondaryButtonComponent)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  width: auto;
  &.prfShowMore {
    width: 100% !important;
    font-size: ${props => props.theme.fontSize.secondary};
  }

  @media only screen and (max-width: 830px) {
    &.prfShowMore {
      width: 88% !important;
      font-size: ${props => props.theme.fontSize.quaternary};
    }
  }

  @media only screen and (max-width: 767.92px) {
    width: auto;
  }
  @media only screen and (max-width: 576px) {
    width: auto;
  }
`;

export const HitASnag = styled(InvestmentOption)`
  color: ${props => props.theme.fontColors.headingColor};
  &:hover {
    color: ${props => props.theme.fontColors.headingColor};
  }
  @media only screen and (max-width: 990px) {
    letter-spacing: ${props => props.theme.letterSpacing.normal};  
    font-size: ${props => props.theme.fontSize.h5} !important;
    line-height: ${props => props.theme.lineHeight.h5} !important;
  } 
`;

export const ContactUs = styled(DataHeading)`
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.secondary};
`;

/*********************************** MY PROFILE ************************************************/

export const UserContainer = styled.div`
  margin-top: 2.125rem;
  margin-bottom: 3.125rem;
`;

export const UserName = styled.div`
  font-size: ${props => props.theme.fontSize.h4};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.normal};
  color: ${props => props.theme.fontColors.textColor};
  padding-bottom: 1rem;
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h5};
  }
  @media only screen and (max-width: 991px) {
     &&.myProfileUsername {
      font-size: ${props => props.theme.fontSize.h5};
    }
  }
`;

export const UserContributionDetails = styled.div`
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.thead};
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
  &&.myProfileContactType {
    color: ${props => props.theme.fontColors.greyishBrown};
    @media (max-width: 991px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
`;

export const UserContributionContactDetails = styled(UserContributionDetails)`
  line-height: ${props => props.theme.lineHeight.twoRem};
  display:flex;
  align-items:baseline;
  padding-right:2px;
  &&.myProfileContactType {
    color: ${props => props.theme.fontColors.greyishBrown};
    @media (max-width: 991px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
`;

export const SecurityDetailsAccess = styled.div`
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};  
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.secondary};
  color: ${props => props.theme.fontColors.headingColor};
  margin-top: 30px;
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary}
  }
  @media only screen and (max-width: 991px) {
    &&.myProfileFontFix {
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }
`;

export const SecurityAnswerAccess = styled.div`
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};  
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.twoRem};
  color: ${props => props.theme.fontColors.thead};
`;

export const UserEmail = styled.span`
  padding-left: 0.2rem;
  padding-top: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.headingColor};
  &.breakContent {
    word-break: break-all;
  }
`

export const UserNameBlock = styled(UserContributionDetails)`
  display: inline-block;  
  padding-top: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.headingColor};
  &.breakContent {
    word-break: break-word;
    -ms-word-wrap: break-word;
  }
`;

export const UserDateDetails = styled(UserContributionDetails)`
  display: inline-block;
  padding-left: 0.2rem;
  padding-top: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.headingColor};
  &.breakContent {
    word-break: break-all;
  }
  &.breakWord {
    word-break: break-word;
    -ms-word-wrap: break-word;
  }
`;
export const BlockContainer = styled.div`
  margin-bottom: 50px;
`;

export const ProfileSectionHeading = styled(PageSectionHeading)`
  padding-bottom: 1.875rem;
  font-family: ${props=>props.theme.fontFamily.berkeleyStd};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h5}
  }
  @media only screen and (max-width: 990px) {
    line-height: ${props => props.theme.lineHeight.h5} !important;
  }
`;

export const ProfileInformationHeading = styled.div`
  padding-bottom: 0.8125rem;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};  
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.normal};
  color: ${props => props.theme.fontColors.headingColor};
  font-size: ${props => props.theme.fontSize.primary};
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary}
  }
  @media only screen and (max-width: 991px) {
    &&.myProfileFontFix {
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }
`;
export const ProfileFlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ProfileBlockContainer = styled.div`
  display: block;
`;

export const ProfileAddressContainer = styled.div`
  padding: 0 40px 30px 0;
  &.addrWrapper {
    width: 100%;    
    overflow: hidden;
  }
`;

export const AddressDetails = styled.div`
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.headingColor};
  word-break: break-word;
  -ms-word-wrap: break-word;
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary}
  }
`;

export const DetailsData = styled.div`
  &.wrapContent {
    width: 100%;
    word-break: break-all;
  }
  padding-bottom: 2.125rem;
  &.addressWrapper {
    width: 100%;
  }
  @media only screen and (min-width: 991px) {
  &.myProfilemfaEmailSection
  {
    width: 200px;
  }
}
@media only screen and (max-width: 991px) {
  &.myProfilemfaEmailSection
  {
    width: 200px;
  }
}
`;

export const FirstColumn = styled(Col)`
  border-right: solid 1px ${props => props.theme.border.filledTabsInactive};  
  @media only screen and (max-width: 990px) {
    border-right: none;
  }
`;

export const SecondColumn = styled(Col)`
  padding-left: 50px;
  @media only screen and (max-width: 990px) {
    padding-left: 0px;
  }
`;

export const HorizontalDivider = styled(Divider)`
  border-bottom: solid 1px #bfbfbf;
  &.noMargin {
    margin: ${props => props.theme.spacing.margins.noMargin};
  }
  &.blurify {
    margin-bottom: 3rem;
    opacity: 0.4;
  }
  @media only screen and (max-width: 990px) {
    margin: 0rem;
    margin-bottom: 1rem;
  }
`;

export const IconContainer = styled.div`
  margin-right: 1rem;
  line-height: ${props => props.theme.lineHeight.tertiary};
`;
export const DetailsContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const RadioButtonContainer = styled(DisplayFlex)`
  display: flex;
  margin-top: 3.125rem;
  justify-content: space-between;
`;
export const SaveButton = styled(PrimaryButtonComponent)`
  width: 9.375rem;
  @media (min-width: 320px) and (max-width: 990px) {
    width: 9.375rem;
  }
`;
export const DisableSaveButton = styled(SaveButton)`
  width: 9.375rem;
  cursor: not-allowed !important;
  background: #dddddd;
  cursor: none;
  @media (min-width: 320px) and (max-width: 990px) {
    width: 9.375rem;
  }
`;

export const DoneButtonComponent = styled(GhostButtonComponent)`
  font-size: ${props => props.theme.fontSize.heading};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
  }
`;

export const CancelButton = styled(GhostButtonComponent)`
  width: 9.375rem;
  @media (min-width: 320px) and (max-width: 990px) {
    width: 9.375rem;
  }
`;
export const RowProfileInformationHeading = styled(ProfileInformationHeading)`
  font-size: ${props => props.theme.fontSize.primary};
`;

export const DefaultIndicator = styled(PrimaryIndicator)`
  display: inline-block;
  padding: 0px;
  margin-left: 0.375rem;
  /* margin-top: 0.175rem; */
  line-height: ${props => props.theme.lineHeight.tableFont};
  height: 22px;
  flex:0 0 auto;
  &.veremail-mt-30 {
    margin-top: 30px;
    width: auto;
    padding: 0 10px;
    margin-left: 0px;
  }
  @media (min-width: 320px) and (max-width: 990px) {
    margin-left: 1.375rem;
    /* margin-top: 0.175rem; */
  }
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const ModalButtonContainerchangePhNo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CustomisedTable = styled(Table)`
  background-color: ${props =>
    props.cardIndex % 2 == 0 ? "#f4f3f3" : "white"};
`;

/*********************************** CUSTOMISED TABLE ************************************************/

export const ProfileTable = styled(CommonTable)`
  &.profileTable {
    .ant-table-thead > tr > th .ant-table-column-sorter {
      display: block;
    }
  }
  .ant-table-thead
    > tr
    > th.ant-table-column-has-actions.ant-table-column-has-sorters,
  .ant-table-thead
    > tr
    > th.ant-table-column-has-actions.ant-table-column-has-filters {
    padding-right: 0px !important;
  }
  .ant-table-tbody > tr > td {
    border: none !important;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    &.ant-table-row {
      padding: 20px 0px 20px 20px !important;
    }
  }

  .ant-table-tbody > tr.ant-table-row > td:first-child{
    padding-left: 30px;
  }

  .ant-table-tbody > tr.ant-table-row > td:last-child {
    padding: 20px 20px 20px 20px !important;
  }

  .ant-table-thead > tr > th {
    padding: 20px 0px 20px 20px !important;
  }
  
  tr.ant-table-expanded-row > td {
    padding: 0px !important;
  }

  .prfExpandTable{
    padding: 20px 20px 20px 20px;
    border-top: 1px solid #d4d4d4;
    cursor: default;
  } 

  tr.grayScale + tr.ant-table-expanded-row {
    background-color: ${props => props.theme.backgroundColor.lightGrey};
    padding: 0px !important;
  }

  tr.whiteScale + tr.ant-table-expanded-row {
    background-color:  ${props => props.theme.backgroundColor.layoutLight};
    padding: 0px !important;
  }

  tr.grayScale {
    background-color: ${props => props.theme.backgroundColor.lightGrey} !important;
  }

  tr.whiteScale {
    background-color: ${props => props.theme.backgroundColor.layoutLight} !important;
  }
  
  td.ant-table-column-has-actions {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.colors.tabHead};
    letter-spacing: ${props => props.theme.letterSpacing.normal} !important;
    line-height: ${props => props.theme.lineHeight.primary};
    a {
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      letter-spacing: ${props => props.theme.letterSpacing.normal};
    }
    span > div {
      padding: 0px;
      letter-spacing: ${props => props.theme.letterSpacing.normal};
      line-height: ${props => props.theme.lineHeight.tertiary};
      height: 18px;
    }
  }

  @media (max-width: 1100px) {
    td.ant-table-column-has-actions > span >  div {
      padding: 2px;
    }
  }

  @media (max-width: 1189px) {
    .ant-table-column-title{
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }

  // ----end of ant-table-row

  .ant-table-fixed-header {
    .ant-table-scroll {
      .ant-table-header {
        padding-bottom: 0px !important;
        margin-bottom: -6px !important;
        background: #ffffff;
      }
      border-width: 0px 1px 1px 1px !important;
      border-style: solid !important;
      border-color: #eaeaea !important;
    }
  }

  th {
    background: #fff !important;
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-style: normal;
    font-stretch: ${props => props.theme.fontStretch.normal};
    color: ${props => props.theme.fontColors.primaryColor} !important;
    font-size: ${props => props.theme.fontSize.primary};
    font-style: normal;
    font-stretch: normal;
    line-height: ${props => props.theme.lineHeight.tertiary};
    letter-spacing: ${props => props.theme.letterSpacing.zero};
  }
  .ant-table-thead > tr > th .ant-table-column-sorter {    
    width: 14px;
    height: 17px;    
    color: ${props => props.theme.border.filledTabsInactive};    
    transition: all 0.3s;
  }
  .ant-table-thead
    > tr
    .ant-table-column-has-actions.ant-table-column-has-sorters {
    padding-left: 0px !important;
  }

  .ant-table-thead
    > tr
    > th
    .ant-table-column-sorter
    .ant-table-column-sorter-inner {
    height: 1em;
    margin-top: 0 !important;
    margin-left: 0 !important;
    color: ${props => props.theme.border.filledTabsInactive};
    line-height: 1em;
    text-align: center;
    transition: all 0.3s;
  }
  .ant-table-column-has-actions.ant-table-column-has-sorters > span {
    display: flex;
  }
  .ant-table-column-has-actions.ant-table-column-has-sorters > span > div {
    margin-top: 0.175rem;    
  }
  .ant-table-column-sorters {        
    display: flex !important;
  }
  .ant-table-thead {
    tr {
      th {
        width: 16%;
        .ant-table-column-sorter {
          left: 0px;
          right: 0px;
          top: 0px;
          text-align: left;
          position: relative;
        }
        border-bottom-width: 2px;
        border-bottom-style: solid;
        border-bottom-color: #eaeaea;
      }
      .ant-table-selection-column {
        width: 5%;
      }
    }
  }

  .expandContainer {    
    display: flex;

    div.ant-col-lg-8 {
      border-right: 1px solid #d4d4d4;
    }

    div.ant-col-lg-8:first-child{
      padding-right: 30px;
    }

    div.ant-col-lg-8:nth-child(2){
      padding: 0px 30px;
    }

    div.ant-col-lg-8:last-child {
      padding: 0px 30px;
      border-right: transparent;
    }
  }
  &&.profileInfoTable .ant-table-tbody > tr: hover {
    cursor: pointer;
  }

`;
/*********************************** CUSTOMISED TABLE END ************************************************/

export const CustomisedDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 692px !important;
    @media (min-width: 320px) and (max-width: 990px) {
      width: 100% !important;
    }
  }
  .ant-drawer-body {
    padding: 0 !important;
  }

  .ant-btn-primary {
    color: #fff;
    background-color: ${props => props.theme.fontColors.primary};
    width: 300px;
    height: 40px;
    border-radius: 0rem;
    border-color: transparent;
    @media (min-width: 320px) and (max-width: 990px) {
      width: 100% !important;
    }
  }
  .ant-drawer-close i svg {
    height: 24.8px;
    width: 25px;
    display: none;
  }
  .has-error .ant-form-explain {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
`;

export const DrawerContainer = styled.div`
  padding: 3.75rem 5rem 0 5rem;  
  @media (max-width: 576px) {
    padding: 50px;
  }
  @media (max-width: 320px) {
    padding: 50px 43px 50px 43px;
  }
`;

export const DrawerSectionContent = styled.div`
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.secondary};
  color: ${props => props.theme.fontColors.thead};
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const DrawerSectionHeading = styled(PageSectionHeading)`
  margin: 0 0 1.25rem 0;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h2};
  
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h3};
  }
`;

export const CustomisedForm = styled(Form)`
  margin-top: 3rem;
  .ant-form-item-label {
    white-space: initial !important;
  }
  .ant-form-item-label > label::after {
    content: none !important;
    position: relative;
    top: -0.5px;
    margin: 0 8px 0 2px;
  }
  .ant-form-item-control-wrapper {
    width: 18.75rem;
    @media (min-width: 320px) and (max-width: 990px) {
      width: 100% !important;
    }
  }

  .ant-form-item {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: ${props => props.theme.fontSize.secondary};
    font-variant: tabular-nums;
    line-height: ${props => props.theme.lineHeight.primary};
    list-style: none;

    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum", "tnum";
    margin-bottom: 3.125rem !important;
    vertical-align: top;
  }  
`;

export const CustomisedFormItem = styled(Form.Item)` 
 .ant-form-explain{
   position: absolute;
 }
`;

export const SecurityQuestionLabel= styled.div`
  font-family: ${props => props.theme.fontFamily.HelveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  @media only screen and (max-width: 990px) {
    &&.myProfileSecurityQuestion {
     letter-spacing: ${props => props.theme.letterSpacing.zero};  
     line-height: ${props => props.theme.lineHeight.secondary} !important;
     font-size: ${props => props.theme.fontSize.secondary};
     color: ${props => props.theme.fontColors.textColor};
  } 
`;

export const CustomisedSelectForm = styled(Form)`
  margin-top: 3rem;
  .ant-form-item-label > label::after {
    content: none !important;
    position: relative;
    top: -0.5px;
    margin: 0 8px 0 2px;
  }
  .ant-form-item-control-wrapper {
    width: 100%;
    @media (min-width: 320px) and (max-width: 990px) {
      width: 100% !important;
    }
  }

  .ant-form-item:nth-child(odd) {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: ${props => props.theme.fontSize.secondary};
    font-variant: tabular-nums;
    line-height: ${props => props.theme.lineHeight.primary};
    list-style: none;
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum", "tnum";
    margin-bottom: 0.625rem !important;
    vertical-align: top;
  }

  .ant-form-item:nth-child(even) {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: ${props => props.theme.fontSize.secondary};
    font-variant: tabular-nums;
    line-height: ${props => props.theme.lineHeight.primary};
    list-style: none;
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum", "tnum";
    margin-bottom: 3.125rem !important;
    vertical-align: top;
  }
`;

export const FormLabel = styled.div`
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.isFontHelveticaNeue ? props.theme.fontFamily.helveticaNeue : props.theme.fontFamily.helveticaNeueBold};  
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.oneP17};
  color: ${props => props.theme.fontColors.headingColor};
  padding-bottom: ${props => props.noPaddingBottom ? 0 : props.theme.spacing.paddings.paddingDesRight};
  @media only screen and (max-width: 991px) {
    &&.myProfileSecurityQuestion, &&.myProfileSecurityQuestion div {
     letter-spacing: ${props => props.theme.letterSpacing.zero};  
     line-height: ${props => props.theme.lineHeight.secondary} !important;
     font-size: ${props => props.theme.fontSize.secondary};
    }
    &&.currentPassword {
      color: ${props => props.theme.fontColors.textColor};
    }
   }
`;

export const CustomisedInput = styled(InputField)`
  &[disabled] {
    color: ${props => props.theme.colors.tabHead};
    }
  width: 18.75rem !important;
  height: 2.5rem !important;
  padding:4px 11px;
  margin-top: 10px;
  font-size: ${props => props.theme.fontSize.secondary};
  @media (min-width: 320px) and (max-width: 990px) {
    width: 100% !important;
    &&.securityQuesAnswer {
      font-size: ${props => props.theme.fontSize.secondary};
      .ant-input::placeholder {
        color: ${props => props.theme.fontColors.placeholder} !important;
        opacity: 1;
      }
      .ant-input:-ms-input-placeholder {
        color: ${props => props.theme.fontColors.placeholder} !important; 
      }
    }
  }
  &.full-width {
    width: 100% !important;
  }
`;

export const customisedDivider = styled(Divider)`
  border-bottom: solid 1px ${props => props.theme.fontColors.tbody};
  @media only screen and (max-width: 990px) {
    margin-bottom: 1.875rem;
  }
`;

export const ErrorResponse = styled.div`
  padding: 20px 0px 20px 0px;
  color: ${props => props.theme.colors.error};
`;

export const SecQuest = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.normal};
  color: ${props => props.theme.fontColors.thead};
  padding-top: 0.625rem;
`;

/*********************************** MY PROFILE MOBILE ************************************************/

export const ProfileMobileCard = styled(CommonCard)`
  background-color: ${props => (props.cardIndex % 2 == 0 ? "#f4f3f3" : "white")};
  padding: 20px;
  margin-top: 20px;
  box-shadow: ${props =>
    props.activeCard ? "0 0 15px 0 rgba(0, 0, 0, 0.2)" : "initial"};
`;

export const MobileCardHeading = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};  
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.normal};
  color: ${props => props.theme.colors.primaryColor} !important;
  word-break: break-all;
  text-decoration: underline;
  padding-bottom: 1.25rem;
  display: inline-block;
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
  @media only screen and (max-width: 990px) {
    &&.myProfileAccountNameMob {
      line-height: ${props => props.theme.lineHeight.secondary} !important; 
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
`;
export const MobileCardHeadingItems = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.normal};
  color: ${props => props.theme.fontColors.thead};
  padding-bottom: 0.3125rem;
  &&.myProfileNoRecords {
    color: ${props => props.theme.fontColors.greyishBrown};
    font-size: ${props => props.theme.fontSize.primary};
  }
`;

//line added
export const MobileCardHeadingItemsValue = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.secondary};  
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.normal};
  color: ${props => props.theme.fontColors.headingColor};
  padding-bottom: 0.3125rem;
  word-break: break-word;
`;
export const CardPaddingContainer = styled.div`
  padding-left: 1.875rem;
`;
export const MobileCardDisplay = styled.div`
  display: flex;
  padding-bottom: 0.625rem;
`;

export const RadioCardHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  line-height: ${props => props.theme.lineHeight.normal};
  color: ${props => props.theme.fontColors.thead};
  padding-bottom: 1.25rem;
`;

export const DataExportPrint = styled(DataValue)`
  margin: 0px 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: block;
  a{
    color: ${props => props.theme.colors.primaryColor};
  }
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  @media (max-width: 990px) {
    margin-left: 0px;
    margin-right: 26px;
  }
`;

export const AddAdvisorLinkButton = styled.div`
  margin-top: 30px !important;
  @media only screen and (max-width: 991px) {
    margin-top: 20px !important;
  }
`;

export const AlertPopUpPrimary = styled(Modal)`
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
    font-size: ${props => props.theme.fontSize.h4};
    color: ${props => props.theme.colors.tabHead};
    text-align: center;
  }
  .ant-modal-header {
    padding-top: 30px;
    border: none;
    border-radius: 0;
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.colors.tabHead};
    text-align: center;
    font-size: ${props => props.theme.fontSize.primary};
    padding:5px 50px;
  }
  @media only screen and (max-width:768px){
    .ant-modal-header {
      padding-top: 20px !important;
    }
    .ant-modal-body {
      font-size: ${props => props.theme.fontSize.secondary};
      padding:5px 20px;
    } 
    .ant-modal-footer > div > .ant-btn-primary {
      width: 100% !important;
    }
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    width: 150px;
    border-radius: 0;
    letter-spacing: ${props => props.theme.letterSpacing.buttonText};
    height: 50px;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};    
    font-size: ${props => props.theme.fontSize.heading};
    line-height: ${props => props.theme.lineHeight.heading};
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.backgroundColor.primaryColor};
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: ${props => props.theme.colors.white};
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.heading};
    color: ${props => props.theme.colors.primaryColor};
    border: 0px solid transparent;
    text-decoration: underline;
  }

  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: ${props => props.theme.colors.primaryColor};
    display:none;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    &&.updateUserIdSuccessAlert {
      .ant-modal-title {
        letter-spacing: ${props => props.theme.letterSpacing.normal};
        color: ${props => props.theme.fontColors.headingColor} !important;
        font-weight: ${props => props.theme.fontWeight.normal};
      }
      .ant-btn-primary {
        letter-spacing: ${props => props.theme.letterSpacing.normal};
      }
    }
  }
  &&.updateUserIdSuccessAlert .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
`;

export const FlexAuto = styled.div`
  flex:0 0 auto;
`;

export const FlexBox = styled.div`
  display:flex;
`;


export const Loader = styled(DataValue)`
  
`;

export const UpdateButton = styled(PrimaryButtonComponent)`
  border-radius: 0;
  border: ${props => props.theme.border.noBorder};
  width: ${props => props.width ? props.width : "60%"};
  height: 50px;
  margin-bottom: ${props => props.theme.spacing.margins.quaternary};
  font-size: ${props => props.theme.fontSize.heading};
  font-color: ${props => props.theme.colors.white};
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  letter-spacing: ${props => props.theme.letterSpacing.buttonText};
  line-height: ${props => props.theme.lineHeight.primary};  
  @media only screen and (min-width: 320px) and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    width: 100%;   
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
`;

export const SaveLink = styled.a`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: inline-block;
  &.disable-hyperlink {
    color: ${props => props.theme.fontColors.textColor} !important;
    opacity: 0.5;
    pointer-events: none;
  }
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;
export const LinkCol = styled(Col)`
  margin-bottom:15px;
  @media only screen and (max-width: 767px) {
    margin-bottom:5px;
  }
`;
export const SuccessImg = styled.img`
    width: 64px;
    height: 64px;
    margin-top: 30px;
    margin-bottom: 30px;
`
export const CloseButton = styled.img`
  position: absolute;
  right: 15px;
  top: 15px;
`;
export const DoneButtonWrapper = styled.div`
  @media (min-width:767px) {
    width: 200px;
  }
`;
export const EditButton = styled.div`
  @media (min-width:320px) and (max-width:460px) {
    position: absolute;
    top: 70px;
    right: 10px;
  }
  @media (min-width:320px) and (max-width:360px) {
    top: 68px;
  }
`;
export const AddressWrapper = styled.div`
  max-width: 250px;
`;
export const ItemWrapper = styled.span`
  && {
    @media only screen and (max-width: 991px) {
      font-size: ${props => props.theme.fontSize.secondary};
      &&.myProfileEmail {
        letter-spacing: ${props => props.theme.letterSpacing.zero}; 
      }
    }
  }
`;
export const MyProfileCustomDiv = styled.div``;

export const ProfileLink = styled(UnderlineLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary} !important;
  @media (max-width: 991px) {
    line-height: ${props => props.theme.lineHeight.secondary};
    font-size: ${props => props.theme.fontSize.secondary} !important;
  }
`;

export const MyProfileTableCardView = styled(UnderlineLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold} !important;
  color: ${props => props.theme.colors.primaryColor} !important;
  word-break: break-all;
  text-decoration: underline;
  padding-bottom: 1.25rem;
  display: inline-block;
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
  @media only screen and (max-width: 990px) {
    &&.myProfileAccountNameMob {
      line-height: ${props => props.theme.lineHeight.secondary} !important; 
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
`;
export const EllipsisMfaEmailUnderline = styled(EllipsisUnderline)`

@media only screen and (min-width: 991px) {
  width:200px; 
}
@media only screen and (min-width: 380px) and (max-width: 991px)  {
  width:200px !important; 
}
@media only screen and (min-width: 320px) and (max-width: 380px) {
  max-width:260px;
  width:208px;
}
  ` ;

  export const InlineDiv = styled.div`
    display: inline-block;
  `;